import { getChartTimeParams } from '@op/utils/time';

const SENTIMENT_VALUE_MAP: Record<string, number[]> = {
  Positive: [5],
  Neutral: [3],
  Negative: [1],
};

export interface IGetChartClickParamsOptions {
  event: any;
  paramsKey: { [chartType: string]: any } | string;
  chartType?: string;
  paramsChartType?: string;
  dateType?: string;
  formatParamsKey?: (
    eventKeyValue: string | number | any,
    key: string,
  ) => { [key: string]: any } | string;
}

export function getChartClickParams({
  event,
  paramsKey,
  chartType,
  paramsChartType,
  dateType = 'daily',
  formatParamsKey,
}: IGetChartClickParamsOptions): Record<string, any> {
  const activeChartType = paramsChartType || chartType;
  if (typeof paramsKey === 'object' && paramsKey !== undefined) {
    const selectedParams = paramsKey?.[activeChartType as string] || {};
    if (typeof selectedParams === 'object') {
      return Object.keys(selectedParams).reduce((acc, key) => {
        let eventKeyValue = event?.[selectedParams[key]];
        eventKeyValue =
          formatParamsKey?.(eventKeyValue, key) || eventKeyValue;
        if (
          typeof eventKeyValue === 'object' &&
          eventKeyValue !== undefined
        ) {
          return { ...acc, ...eventKeyValue };
        }

        if (key === 'sentiment') {
          const value = eventKeyValue;
          return { ...acc, [key]: SENTIMENT_VALUE_MAP[value] || [] };
        }
        if (key === 'start_time' || key === 'end_time') {
          const { start_time, end_time } = getChartTimeParams(
            eventKeyValue,
            dateType as any,
          );
          return {
            ...acc,
            [key]: key === 'start_time' ? start_time : end_time,
          };
        }

        if (key === 'review_types' && Array.isArray(eventKeyValue)) {
          return { ...acc, review_types: eventKeyValue };
        }

        const value = Array.isArray(eventKeyValue)
          ? eventKeyValue
          : [eventKeyValue || ''];
        return { ...acc, [key]: value };
      }, {} as Record<string, any>);
    }
    if (typeof selectedParams === 'string') {
      return {
        [selectedParams]: event?.[selectedParams] || '',
      };
    }
    return selectedParams;
  }
  const value = event?.[paramsKey as string] || event;
  return {
    [paramsKey as string]: Array.isArray(value) ? value : [value || ''],
  };
}
